module.exports = __webpack_public_path__ + "static/media/times.84db3367.svg";